import { sortByName } from './arrayHelpers';

const sortTree = data => {
  const treeData = { ...data };
  const tree = treeData.properties;
  if (tree.length) {
    treeData.properties
      .sort(sortByName)
      .forEach(({ fields }) =>
        fields
          .sort(sortByName)
          .forEach(({ cropzones }) => cropzones.sort(sortByName))
      );

    return treeData;
  }
  return treeData;
};
export default sortTree;
